/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { Decimal } from 'decimal.js';
import { toDollar } from '../../utils/money';
import { Brand } from '../brand';

/**
 * Mapping from ISO 3166-1 alpha-2 country code to currency code
 */
export enum CountryCodeToCurrencyNameMap {
  /**
   * Antarctica (Dollar)
   */
  AQ = 'USD',
  /**
   * Austria (Euro)
   */
  AT = 'EUR',
  /**
   * Canada (Dollar)
   */
  CA = 'CAD',
  /**
   * Switzerland (Franc)
   */
  CH = 'CHF',
  /**
   * Czech Republic (Koruna)
   */
  CZ = 'CZK',
  /**
   * Germany (Euro)
   */
  DE = 'EUR',
  /**
   * Spain (Euro)
   */
  ES = 'EUR',
  /**
   * France (Euro)
   */
  FR = 'EUR',
  /**
   * United Kingdom (Pound)
   */
  GB = 'GBP',
  /**
   * Indonesia (Rupiah)
   */
  ID = 'IDR',
  /**
   * Japan (Yen)
   */
  JP = 'JPY',
  /**
   * South Korea (Won)
   */
  KR = 'KRW',
  /**
   * Malaysia (Ringgit)
   */
  MY = 'MYR',
  /**
   * Netherlands (Euro)
   */
  NL = 'EUR',
  /**
   * New Zealand (Dollar)
   */
  NZ = 'NZD',
  /**
   * Poland (Zloty)
   */
  PL = 'PLN',
  /**
   * Portugal (Euro)
   */
  PT = 'EUR',
  /**
   * Romania (Leu)
   */
  RO = 'RON',
  /**
   * Singapore (Dollar)
   */
  SG = 'SGD',
  /**
   * Thailand (Baht)
   */
  TH = 'THB',
  /**
   * Taiwan (Dollar)
   */
  TW = 'TWD',
  /**
   * United States (Dollar)
   */
  US = 'USD',
  /**
   * South Africa (Rand)
   */
  ZA = 'ZAR',
}

/**
 * Any valid ISO 3166-1 alpha-3 (3 character) country code
 */
export enum IsoCountryCode {
  /**
   * Antarctica (AQ)
   */
  ATA = 'ATA',
  /**
   * Austria (AT)
   */
  AUT = 'AUT',
  /**
   * Canada (CA)
   */
  CAN = 'CAN',
  /**
   * Switzerland (CH)
   */
  CHE = 'CHE',
  /**
   * Czech Republic (CZ)
   */
  CZE = 'CZE',
  /**
   * Germany (DE)
   */
  DEU = 'DEU',
  /**
   * Spain (ES)
   */
  ESP = 'ESP',
  /**
   * France (FR)
   */
  FRA = 'FRA',
  /**
   * United Kingdom (GB)
   */
  GBR = 'GBR',
  /**
   * Indonesia (ID)
   */
  IDN = 'IDN',
  /**
   * Japan (JP)
   */
  JPN = 'JPN',
  /**
   * South Korea (KR)
   */
  KOR = 'KOR',
  /**
   * Malaysia (MY)
   */
  MYS = 'MYS',
  /**
   * Netherlands (NL)
   */
  NLD = 'NLD',
  /**
   * New Zealand (NZ)
   */
  NZL = 'NZL',
  /**
   * Poland (PL)
   */
  POL = 'POL',
  /**
   * Portugal (PT)
   */
  PRT = 'PRT',
  /**
   * Romania (RO)
   */
  ROU = 'ROU',
  /**
   * Singapore (SG)
   */
  SGP = 'SGP',
  /**
   * Thailand (TH)
   */
  THA = 'THA',
  /**
   * Taiwan (TW)
   */
  TWN = 'TWN',
  /**
   * United States (US)
   */
  USA = 'USA',
  /**
   * South Africa (ZA)
   */
  ZAF = 'ZAF',
}

/**
 * Any valid ISO 3166-1 alpha-2 (2 character) country code
 */
export enum IsoCountryCode2Char {
  /**
   * Antarctica (ATA)
   */
  AQ = 'AQ',
  /**
   * Austria (AUT)
   */
  AT = 'AT',
  /**
   * Canada (CAN)
   */
  CA = 'CA',
  /**
   * Switzerland (CHE)
   */
  CH = 'CH',
  /**
   * Czech Republic (CZE)
   */
  CZ = 'CZ',
  /**
   * Germany (DEU)
   */
  DE = 'DE',
  /**
   * Spain (ESP)
   */
  ES = 'ES',
  /**
   * France (FRA)
   */
  FR = 'FR',
  /**
   * United Kingdom (GBR)
   */
  GB = 'GB',
  /**
   * Indonesia (IDN)
   */
  ID = 'ID',
  /**
   * Japan (JPN)
   */
  JP = 'JP',
  /**
   * South Korea (KOR)
   */
  KR = 'KR',
  /**
   * Malaysia (MYS)
   */
  MY = 'MY',
  /**
   * Netherlands (NLD)
   */
  NL = 'NL',
  /**
   * New Zealand (NZL)
   */
  NZ = 'NZ',
  /**
   * Poland (POL)
   */
  PL = 'PL',
  /**
   * Portugal (PRT)
   */
  PT = 'PT',
  /**
   * Romania (ROU)
   */
  RO = 'RO',
  /**
   * Singapore (SGP)
   */
  SG = 'SG',
  /**
   * Thailand (THA)
   */
  TH = 'TH',
  /**
   * Taiwan (TWN)
   */
  TW = 'TW',
  /**
   * United States (USA)
   */
  US = 'US',
  /**
   * South Africa (ZAF)
   */
  ZA = 'ZA',
}

export enum IsoCountryCodeToCurrencyNameMap {
  /**
   * Antarctica (ATA)
   */
  ATA = 'USD',
  /**
   * Austria (AUT)
   */
  AUT = 'EUR',
  /**
   * Canada (CAN)
   */
  CAN = 'CAD',
  /**
   * Switzerland (CHE)
   */
  CHE = 'CHF',
  /**
   * Czech Republic (CZE)
   */
  CZE = 'CZK',
  /**
   * Germany (DEU)
   */
  DEU = 'EUR',
  /**
   * Spain (ESP)
   */
  ESP = 'EUR',
  /**
   * France (FRA)
   */
  FRA = 'EUR',
  /**
   * United Kingdom (GBR)
   */
  GBR = 'GBP',
  /**
   * Indonesia (IDN)
   */
  IDN = 'IDR',
  /**
   * Japan (JPN)
   */
  JPN = 'JPY',
  /**
   * South Korea (KOR)
   */
  KOR = 'KRW',
  /**
   * Malaysia (MYS)
   */
  MYS = 'MYR',
  /**
   * Netherlands (NLD)
   */
  NLD = 'EUR',
  /**
   * New Zealand (NZL)
   */
  NZL = 'NZD',
  /**
   * Poland (POL)
   */
  POL = 'PLN',
  /**
   * Portugal (PRT)
   */
  PRT = 'EUR',
  /**
   * Romania (ROU)
   */
  ROU = 'RON',
  /**
   * Singapore (SGP)
   */
  SGP = 'SGD',
  /**
   * Thailand (THA)
   */
  THA = 'THB',
  /**
   * Taiwan (TWN)
   */
  TWN = 'TWD',
  /**
   * United States (USA)
   */
  USA = 'USD',
  /**
   * South Africa (ZAF)
   */
  ZAF = 'ZAR',
}

/**
 * All valid locales for money formatting library
 */
export enum MoneyFormatLocale {
  'en-au' = 'en-au',
  'de-at' = 'de-at',
  'fr-ch' = 'fr-ch',
  'cs' = 'cs',
  'de' = 'de',
  'es-es' = 'es-es',
  'fr-fr' = 'fr-fr',
  'en-gb' = 'en-gb',
  'id' = 'id',
  'ja' = 'ja',
  'ko-kr' = 'ko-kr',
  'ms-my' = 'ms-my',
  'nl-nl' = 'nl-nl',
  'en-nz' = 'en-nz',
  'pl' = 'pl',
  'pt-pt' = 'pt-pt',
  'ro' = 'ro',
  'cmn' = 'cmn',
  'th' = 'th',
  'zh-tw' = 'zh-tw',
  'en-za' = 'en-za',
}

/**
 * Object mapping ISO 3166-1 alpha-2 (2 character) country code to ISO 3166-1 alpha-3 (3 character) country code
 */
export const countryCodeToIsoCountryCodeMap: { [key: string]: IsoCountryCode } = {
  [IsoCountryCode2Char.AQ]: IsoCountryCode.ATA,
  [IsoCountryCode2Char.AT]: IsoCountryCode.AUT,
  [IsoCountryCode2Char.CA]: IsoCountryCode.CAN,
  [IsoCountryCode2Char.CH]: IsoCountryCode.CHE,
  [IsoCountryCode2Char.CZ]: IsoCountryCode.CZE,
  [IsoCountryCode2Char.DE]: IsoCountryCode.DEU,
  [IsoCountryCode2Char.ES]: IsoCountryCode.ESP,
  [IsoCountryCode2Char.FR]: IsoCountryCode.FRA,
  [IsoCountryCode2Char.GB]: IsoCountryCode.GBR,
  [IsoCountryCode2Char.ID]: IsoCountryCode.IDN,
  [IsoCountryCode2Char.JP]: IsoCountryCode.JPN,
  [IsoCountryCode2Char.KR]: IsoCountryCode.KOR,
  [IsoCountryCode2Char.MY]: IsoCountryCode.MYS,
  [IsoCountryCode2Char.NL]: IsoCountryCode.NLD,
  [IsoCountryCode2Char.NZ]: IsoCountryCode.NZL,
  [IsoCountryCode2Char.PL]: IsoCountryCode.POL,
  [IsoCountryCode2Char.PT]: IsoCountryCode.PRT,
  [IsoCountryCode2Char.RO]: IsoCountryCode.ROU,
  [IsoCountryCode2Char.SG]: IsoCountryCode.SGP,
  [IsoCountryCode2Char.TH]: IsoCountryCode.THA,
  [IsoCountryCode2Char.TW]: IsoCountryCode.TWN,
  [IsoCountryCode2Char.US]: IsoCountryCode.USA,
  [IsoCountryCode2Char.ZA]: IsoCountryCode.ZAF,
};

/**
 * Record mapping ISO 3166-1 alpha-2 (2 character) country code to ISO 3166-1 alpha-3 (3 character) country code
 */
export const ISO2_ISO_MAPPING: Record<IsoCountryCode2Char, IsoCountryCode> = {
  [IsoCountryCode2Char.AQ]: IsoCountryCode.ATA,
  [IsoCountryCode2Char.AT]: IsoCountryCode.AUT,
  [IsoCountryCode2Char.CA]: IsoCountryCode.CAN,
  [IsoCountryCode2Char.CH]: IsoCountryCode.CHE,
  [IsoCountryCode2Char.CZ]: IsoCountryCode.CZE,
  [IsoCountryCode2Char.DE]: IsoCountryCode.DEU,
  [IsoCountryCode2Char.ES]: IsoCountryCode.ESP,
  [IsoCountryCode2Char.FR]: IsoCountryCode.FRA,
  [IsoCountryCode2Char.GB]: IsoCountryCode.GBR,
  [IsoCountryCode2Char.ID]: IsoCountryCode.IDN,
  [IsoCountryCode2Char.JP]: IsoCountryCode.JPN,
  [IsoCountryCode2Char.KR]: IsoCountryCode.KOR,
  [IsoCountryCode2Char.MY]: IsoCountryCode.MYS,
  [IsoCountryCode2Char.NL]: IsoCountryCode.NLD,
  [IsoCountryCode2Char.NZ]: IsoCountryCode.NZL,
  [IsoCountryCode2Char.PL]: IsoCountryCode.POL,
  [IsoCountryCode2Char.PT]: IsoCountryCode.PRT,
  [IsoCountryCode2Char.RO]: IsoCountryCode.ROU,
  [IsoCountryCode2Char.SG]: IsoCountryCode.SGP,
  [IsoCountryCode2Char.TH]: IsoCountryCode.THA,
  [IsoCountryCode2Char.TW]: IsoCountryCode.TWN,
  [IsoCountryCode2Char.US]: IsoCountryCode.USA,
  [IsoCountryCode2Char.ZA]: IsoCountryCode.ZAF,
};

/**
 * Record mapping ISO 3166-1 alpha-3 (3 character) country code to ISO 3166-1 alpha-2 (2 character) country code
 */
export const ISO_ISO2_MAPPING: Record<IsoCountryCode, IsoCountryCode2Char> = {
  [IsoCountryCode.ATA]: IsoCountryCode2Char.AQ,
  [IsoCountryCode.AUT]: IsoCountryCode2Char.AT,
  [IsoCountryCode.CAN]: IsoCountryCode2Char.CA,
  [IsoCountryCode.CHE]: IsoCountryCode2Char.CH,
  [IsoCountryCode.CZE]: IsoCountryCode2Char.CZ,
  [IsoCountryCode.DEU]: IsoCountryCode2Char.DE,
  [IsoCountryCode.ESP]: IsoCountryCode2Char.ES,
  [IsoCountryCode.FRA]: IsoCountryCode2Char.FR,
  [IsoCountryCode.GBR]: IsoCountryCode2Char.GB,
  [IsoCountryCode.IDN]: IsoCountryCode2Char.ID,
  [IsoCountryCode.JPN]: IsoCountryCode2Char.JP,
  [IsoCountryCode.KOR]: IsoCountryCode2Char.KR,
  [IsoCountryCode.MYS]: IsoCountryCode2Char.MY,
  [IsoCountryCode.NLD]: IsoCountryCode2Char.NL,
  [IsoCountryCode.NZL]: IsoCountryCode2Char.NZ,
  [IsoCountryCode.POL]: IsoCountryCode2Char.PL,
  [IsoCountryCode.PRT]: IsoCountryCode2Char.PT,
  [IsoCountryCode.ROU]: IsoCountryCode2Char.RO,
  [IsoCountryCode.SGP]: IsoCountryCode2Char.SG,
  [IsoCountryCode.THA]: IsoCountryCode2Char.TH,
  [IsoCountryCode.TWN]: IsoCountryCode2Char.TW,
  [IsoCountryCode.USA]: IsoCountryCode2Char.US,
  [IsoCountryCode.ZAF]: IsoCountryCode2Char.ZA,
};

/**
 * Maps an upper case country name to the ISO 3166-1 alpha-2 (2 character) country code
 */
export const UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED: Record<
  string,
  IsoCountryCode2Char
> = {
  ['ANTARCTICA']: IsoCountryCode2Char.AQ,
  ['AUSTRIA']: IsoCountryCode2Char.AT,
  ['CANADA']: IsoCountryCode2Char.CA,
  ['CZECH REPUBLIC']: IsoCountryCode2Char.CZ,
  ['FRANCE']: IsoCountryCode2Char.FR,
  ['GERMANY']: IsoCountryCode2Char.DE,
  ['INDONESIA']: IsoCountryCode2Char.ID,
  ['JAPAN']: IsoCountryCode2Char.JP,
  ['MALAYSIA']: IsoCountryCode2Char.MY,
  ['NETHERLANDS']: IsoCountryCode2Char.NL,
  ['NEW ZEALAND']: IsoCountryCode2Char.NZ,
  ['POLAND']: IsoCountryCode2Char.PL,
  ['PORTUGAL']: IsoCountryCode2Char.PT,
  ['ROMANIA']: IsoCountryCode2Char.RO,
  ['SINGAPORE']: IsoCountryCode2Char.SG,
  ['SOUTH AFRICA']: IsoCountryCode2Char.ZA,
  ['SOUTH KOREA']: IsoCountryCode2Char.KR,
  ['SPAIN']: IsoCountryCode2Char.ES,
  ['SWITZERLAND']: IsoCountryCode2Char.CH,
  ['TAIWAN']: IsoCountryCode2Char.TW,
  ['THAILAND']: IsoCountryCode2Char.TH,
  ['UNITED KINGDOM']: IsoCountryCode2Char.GB,
  ['UNITED STATES']: IsoCountryCode2Char.US,
};

export type CurrencyFormatter = (value: Decimal.Value) => string;

/**
 * Money format locale for given country
 *
 * @todo Use a different mechanism for currency formatting
 * @see https://rbictg.atlassian.net/wiki/spaces/IN/pages/3081371649/Email+currencies
 */
export const ISO2_CURRENCY_FORMATTER_MAPPING: Record<IsoCountryCode2Char, CurrencyFormatter> = {
  [IsoCountryCode2Char.AQ]: toDollar(MoneyFormatLocale['en-au']),
  [IsoCountryCode2Char.AT]: toDollar(MoneyFormatLocale['de-at']),
  [IsoCountryCode2Char.CA]: toDollar(MoneyFormatLocale['en-au']),
  [IsoCountryCode2Char.CH]: toDollar(MoneyFormatLocale['fr-ch']),
  [IsoCountryCode2Char.CZ]: toDollar(MoneyFormatLocale['cs']),
  [IsoCountryCode2Char.DE]: toDollar(MoneyFormatLocale['de']),
  [IsoCountryCode2Char.ES]: toDollar(MoneyFormatLocale['es-es']),
  [IsoCountryCode2Char.FR]: toDollar(MoneyFormatLocale['fr-fr']),
  [IsoCountryCode2Char.GB]: toDollar(MoneyFormatLocale['en-gb']),
  [IsoCountryCode2Char.ID]: toDollar(MoneyFormatLocale['id']),
  [IsoCountryCode2Char.JP]: toDollar(MoneyFormatLocale['ja']),
  [IsoCountryCode2Char.KR]: toDollar(MoneyFormatLocale['ko-kr']),
  [IsoCountryCode2Char.MY]: toDollar(MoneyFormatLocale['ms-my']),
  [IsoCountryCode2Char.NL]: toDollar(MoneyFormatLocale['nl-nl']),
  [IsoCountryCode2Char.NZ]: toDollar(MoneyFormatLocale['en-nz']),
  [IsoCountryCode2Char.PL]: toDollar(MoneyFormatLocale['pl']),
  [IsoCountryCode2Char.PT]: toDollar(MoneyFormatLocale['pt-pt']),
  [IsoCountryCode2Char.RO]: toDollar(MoneyFormatLocale['ro']),
  [IsoCountryCode2Char.SG]: toDollar(MoneyFormatLocale['cmn']),
  [IsoCountryCode2Char.TH]: toDollar(MoneyFormatLocale['th']),
  [IsoCountryCode2Char.TW]: toDollar(MoneyFormatLocale['zh-tw']),
  [IsoCountryCode2Char.US]: toDollar(MoneyFormatLocale['en-au']),
  [IsoCountryCode2Char.ZA]: toDollar(MoneyFormatLocale['en-za']),
};

/**
 * Map a country identifier to its ISO 3166-1 numeric code.
 *
 * Allowed inputs:
 * - Country name (title case)
 * - Country name (upper case)
 * - Country name (lower case)
 * - ISO 3166-1 alpha-2 (2 character) country code (lower case)
 * - ISO 3166-1 alpha-2 (2 character) country code (upper case)
 * - ISO 3166-1 alpha-3 (3 character) country code (lower case)
 * - ISO 3166-1 alpha-3 (3 character) country code (upper case)
 *
 * Meant to handle different input shapes since input comes from sanity
 */
export const storeCountryToCurrencyCodeMapGenerated: { [key: string]: number } = {
  ['ANTARCTICA']: 840,
  ['AQ']: 840,
  ['AT']: 978,
  ['ATA']: 840,
  ['AUSTRIA']: 978,
  ['AUT']: 978,
  ['Antarctica']: 840,
  ['Austria']: 978,
  ['CA']: 124,
  ['CAN']: 124,
  ['CANADA']: 124,
  ['CH']: 756,
  ['CHE']: 756,
  ['CZ']: 203,
  ['CZE']: 203,
  ['CZECH REPUBLIC']: 203,
  ['Canada']: 124,
  ['Czech Republic']: 203,
  ['DE']: 978,
  ['DEU']: 978,
  ['ES']: 978,
  ['ESP']: 978,
  ['FR']: 978,
  ['FRA']: 978,
  ['FRANCE']: 978,
  ['France']: 978,
  ['GB']: 826,
  ['GBR']: 826,
  ['GERMANY']: 978,
  ['Germany']: 978,
  ['ID']: 360,
  ['IDN']: 360,
  ['INDONESIA']: 360,
  ['Indonesia']: 360,
  ['JAPAN']: 392,
  ['JP']: 392,
  ['JPN']: 392,
  ['Japan']: 392,
  ['KOR']: 410,
  ['KR']: 410,
  ['MALAYSIA']: 458,
  ['MY']: 458,
  ['MYS']: 458,
  ['Malaysia']: 458,
  ['NETHERLANDS']: 978,
  ['NEW ZEALAND']: 554,
  ['NL']: 978,
  ['NLD']: 978,
  ['NZ']: 554,
  ['NZL']: 554,
  ['Netherlands']: 978,
  ['New Zealand']: 554,
  ['PL']: 985,
  ['POL']: 985,
  ['POLAND']: 985,
  ['PORTUGAL']: 978,
  ['PRT']: 978,
  ['PT']: 978,
  ['Poland']: 985,
  ['Portugal']: 978,
  ['RO']: 946,
  ['ROMANIA']: 946,
  ['ROU']: 946,
  ['Romania']: 946,
  ['SG']: 702,
  ['SGP']: 702,
  ['SINGAPORE']: 702,
  ['SOUTH AFRICA']: 710,
  ['SOUTH KOREA']: 410,
  ['SPAIN']: 978,
  ['SWITZERLAND']: 756,
  ['Singapore']: 702,
  ['South Africa']: 710,
  ['South Korea']: 410,
  ['Spain']: 978,
  ['Switzerland']: 756,
  ['TAIWAN']: 901,
  ['TH']: 764,
  ['THA']: 764,
  ['THAILAND']: 764,
  ['TW']: 901,
  ['TWN']: 901,
  ['Taiwan']: 901,
  ['Thailand']: 764,
  ['UNITED KINGDOM']: 826,
  ['UNITED STATES']: 840,
  ['US']: 840,
  ['USA']: 840,
  ['United Kingdom']: 826,
  ['United States']: 840,
  ['ZA']: 710,
  ['ZAF']: 710,
  ['antarctica']: 840,
  ['aq']: 840,
  ['at']: 978,
  ['ata']: 840,
  ['austria']: 978,
  ['aut']: 978,
  ['ca']: 124,
  ['can']: 124,
  ['canada']: 124,
  ['ch']: 756,
  ['che']: 756,
  ['cz']: 203,
  ['cze']: 203,
  ['czech republic']: 203,
  ['de']: 978,
  ['deu']: 978,
  ['es']: 978,
  ['esp']: 978,
  ['fr']: 978,
  ['fra']: 978,
  ['france']: 978,
  ['gb']: 826,
  ['gbr']: 826,
  ['germany']: 978,
  ['id']: 360,
  ['idn']: 360,
  ['indonesia']: 360,
  ['japan']: 392,
  ['jp']: 392,
  ['jpn']: 392,
  ['kor']: 410,
  ['kr']: 410,
  ['malaysia']: 458,
  ['my']: 458,
  ['mys']: 458,
  ['netherlands']: 978,
  ['new zealand']: 554,
  ['nl']: 978,
  ['nld']: 978,
  ['nz']: 554,
  ['nzl']: 554,
  ['pl']: 985,
  ['pol']: 985,
  ['poland']: 985,
  ['portugal']: 978,
  ['prt']: 978,
  ['pt']: 978,
  ['ro']: 946,
  ['romania']: 946,
  ['rou']: 946,
  ['sg']: 702,
  ['sgp']: 702,
  ['singapore']: 702,
  ['south africa']: 710,
  ['south korea']: 410,
  ['spain']: 978,
  ['switzerland']: 756,
  ['taiwan']: 901,
  ['th']: 764,
  ['tha']: 764,
  ['thailand']: 764,
  ['tw']: 901,
  ['twn']: 901,
  ['united kingdom']: 826,
  ['united states']: 840,
  ['us']: 840,
  ['usa']: 840,
  ['za']: 710,
  ['zaf']: 710,
};

/**
 * Maps brand to supported regions
 */
export const BRAND_TO_SUPPORTED_REGIONS_MAPPING: Record<Brand, IsoCountryCode2Char[]> = {
  [Brand.BK]: [
    IsoCountryCode2Char.CA,
    IsoCountryCode2Char.CH,
    IsoCountryCode2Char.DE,
    IsoCountryCode2Char.GB,
    IsoCountryCode2Char.NZ,
    IsoCountryCode2Char.US,
    IsoCountryCode2Char.ZA,
    IsoCountryCode2Char.NL,
    IsoCountryCode2Char.AQ,
    IsoCountryCode2Char.PT,
    IsoCountryCode2Char.AT,
    IsoCountryCode2Char.CZ,
    IsoCountryCode2Char.PL,
    IsoCountryCode2Char.RO,
    IsoCountryCode2Char.ES,
  ],
  [Brand.LTW]: [IsoCountryCode2Char.US],
  [Brand.PLK]: [
    IsoCountryCode2Char.CA,
    IsoCountryCode2Char.CH,
    IsoCountryCode2Char.US,
    IsoCountryCode2Char.KR,
    IsoCountryCode2Char.ES,
    IsoCountryCode2Char.FR,
    IsoCountryCode2Char.PT,
    IsoCountryCode2Char.SG,
    IsoCountryCode2Char.CZ,
    IsoCountryCode2Char.PL,
    IsoCountryCode2Char.NZ,
    IsoCountryCode2Char.TW,
    IsoCountryCode2Char.TH,
    IsoCountryCode2Char.AQ,
  ],
  [Brand.TH]: [
    IsoCountryCode2Char.CA,
    IsoCountryCode2Char.US,
    IsoCountryCode2Char.ES,
    IsoCountryCode2Char.MY,
    IsoCountryCode2Char.ID,
    IsoCountryCode2Char.KR,
    IsoCountryCode2Char.JP,
    IsoCountryCode2Char.TW,
    IsoCountryCode2Char.AQ,
  ],
  [Brand.FHS]: [
    IsoCountryCode2Char.US,
    IsoCountryCode2Char.CA,
    IsoCountryCode2Char.CH,
    IsoCountryCode2Char.AQ,
  ],
};
